import React, {useEffect, useState} from "react";
import CertificateForm from "./certificateForm";
import SubmitButton from "./submitButton";
import {useBillingContext} from "..";
import APIService from "../../../modules/apiService";
import {formatDate} from "../../../utils/formatters";
import moment from "moment-timezone";

const api = new APIService();

export default function RenewCert() {
  const {showErrorModal, setBillingSettings, billingSettings} = useBillingContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [certAlert, setCertAlert] = useState({type: '', message: ''});

  const [form, setForm] = useState({
    cuit: "",
    clave: "",
  });

  useEffect(() => {
    if (billingSettings) {
      setForm({
        cuit: billingSettings.cuit || "",
      });

      const validUntil = moment(billingSettings.valid_until, "YYYY-MM-DD");
      const daysLeft = validUntil.diff(moment(), "days");

      if (billingSettings.is_valid) {
        if (daysLeft <= 30 && daysLeft >= 0) {
          setCertAlert({
            type: "warning",
            message: `El certificado actual es válido hasta el ${formatDate(billingSettings.valid_until)}. Tené en cuenta que vence en ${daysLeft} día(s).`,
          });
        } else {
          setCertAlert({
            type: "success",
            message: `El certificado actual es válido hasta el ${formatDate(billingSettings.valid_until)}.`,
          });
        }
      } else {
        setCertAlert({
          type: "danger",
          message: "El certificado actual está vencido",
        });
      }
    }
  }, [billingSettings]);

  const handleFormChange = (e) => {
    const newForm = {...form, [e.target.name]: e.target.value};
    setForm(newForm);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsSubmitting(true);
    setErrors({});

    try {
      const response = await api.postRenewCert(form);
      const json = await response.json();

      if (response.ok) {
        setBillingSettings(json.data);

        // Set alert based on certificate validity

      } else if (response.status === 422) {
        setErrors(json?.errors ?? {});
      } else {
        throw new Error(json?.message);
      }
    } catch (err) {
      showErrorModal(err.message);
    }

    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <div className={`alert alert-${certAlert.type} mb-3`} role="alert">
        {certAlert.message}
      </div>
      <CertificateForm
        formData={form}
        errors={errors}
        handleChange={handleFormChange}
        disabled={isSubmitting}
      />
      <SubmitButton
        isSubmitting={isSubmitting}
        submittingText="Renovando..."
        text="Renovar certificado"
      />
    </form>
  );
}
